<template>
  <!--模板管理-->
  <div class="tpl">
    <!-- 文件自定义模板页面时隐藏 面包屑和切换主题组件 -->
    <div class="com-Breadcrumb" v-if="!crumbList.includes($route.path)">
      <el-breadcrumb separator=">">
        <el-breadcrumb-item>
          <router-link class="item" to="/viewIndex">首页</router-link>
        </el-breadcrumb-item>
        <template v-if="isSecondaryMenu">
          <!--          二级菜单-->
          <el-breadcrumb-item v-if="computedCurrentMenuName">
            <router-link class="item" :to="isSecondaryMenu.parentPath">
              {{
              computedCurrentMenuName
              }}
            </router-link>
          </el-breadcrumb-item>
          <el-breadcrumb-item>
            {{
            isSecondaryMenu.routeName
            }}
          </el-breadcrumb-item>
        </template>
        <el-breadcrumb-item v-else>
          {{
          computedCurrentMenuName
          }}
        </el-breadcrumb-item>
      </el-breadcrumb>
      <a class="r-btn" @click="previousStep()">返回上一步</a>
    </div>
    <!-- 1151需求中加入的企业都放入了控制台，就不在工作台显示（不在这里显示）。 -->
    <role-tab
      v-if="!isSecondaryMenu && $route.path != '/tpl/add/addTplPerson' && false"
      :tabs="{
        // haveBind 表示是否要用 binds中的数据
        haveBind: false,
        binds: [],
      }"
      @change="tabHand"
    />
    <div v-if="showMenuTree" class="main-wrap">
      <div class="left-wrap">
        <apply-menu-tree
          ref="menuTree"
          :currentMenuName.sync="currentMenuName"
          :initCallback="initMenuTree"
          :menus="menus"
          :style="{ height: '100%' }"
        ></apply-menu-tree>
      </div>
      <div class="right-wrap">
        <!--        <route-name :propsRouteName="computedCurrentMenuName"-->
        <!--                    :style="{fontSize: '16px', lineHeight: '36px', backgroundColor: '#fff', paddingLeft: '16px', fontWeight: '600', borderBottom: 'solid 1px #E5E5E5'}"/>-->
        <nuxt-child :menus="menus" />
      </div>
    </div>
    <template v-else>
      <nuxt-child :menus="menus" />
    </template>
    <el-dialog
      :visible.sync="dialogFormVisible"
      :title="operGroupType.tplGroupTypeName ? '修改分类' : '添加分类'"
      :close-on-click-modal="false"
      width="260px"
    >
      <el-input
        placeholder="请输入分类名称"
        v-model="operGroupType.tplGroupTypeName"
        size="small"
        :maxlength="10"
      />
      <div slot="footer" class="dialog-footer">
        <el-button @click="saveOrUpdateGroupType()" size="small" type="danger">确定</el-button>
        <el-button @click="dialogFormVisible = false" size="small">取消</el-button>
      </div>
    </el-dialog>
<!--    提示-->
    <el-dialog
      title="提示"
      :visible.sync="userTipdialogVisible"
      width="30%">
      <span>点击左上角头像切换身份</span>
      <span slot="footer" class="dialog-footer">
    <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="userTipdialogVisibleFn">确认</el-button>
      </span>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import ApplyMenuTree from "@/components/apply-menu-tree";
import RouteName from "@/components/route-name";
import RoleTab from "@/components/role-tab";
import { ApiMethods } from "@/assets/js/http-serve/http-methods";
import { mapGetters } from "vuex";
import { isInDingTalk } from "../assets/js/utils/ding-env";
import {setCurrentUser} from "../assets/js/http-serve/corp/common";

export default {
  components: { ApplyMenuTree, RouteName, RoleTab },
  data () {
    return {
      userTipVisible: '',
      userTipdialogVisible: false,
      //layout/default 里面同样配置crumbList
      crumbList: [
        '/tpl/personSet',
        '/tpl/general',
        '/tpl/accountInfo',
        '/tpl/costStatistics',
        '/tpl/signers',
        '/tpl/corpSet',
        '/tpl/add/addTplPerson',
        '/tpl/Preferences',
        '/tpl/myAuth'
      ],
      ignoreLayout: [
        "/tpl/add/api",
        "/tpl/add/apply",
        "/tpl/add/general",
        "/tpl/add/sysContract",
        "/tpl/add/addTplPerson"
      ], // 不用tpl布局的页面
      personMenusAll: [
        // 个人账户
        {
          id: "/tpl/accountInfo",
          label: "账户信息",
          nodeIcon: "icon-tree icon-zh",
          route: {
            path: "/tpl/accountInfo"
          }
        },
        {
          id: "/tpl/personSet",
          label: "印章管理",
          nodeIcon: "icon-tree icon-tpl2",
          route: {
            path: "/tpl/personSet"
          }
        },
        {
          id: "/tpl/general",
          label: "模板管理",
          nodeIcon: "icon-tree icon-tpl1",
          route: {
            path: "/tpl/general"
          }
        },
        {
          id: "/tpl/myAuth",
          label: "我的授权",
          nodeIcon: "icon-tree icon-tpl2",
          route: {
            path: "/tpl/myAuth"
          }
        },
        {
          id: "/tpl/costStatistics",
          label: "消费统计",
          nodeIcon: "icon-tree icon-tj",
          route: {
            path: "/tpl/costStatistics"
          }
        },
        {
          id: "/tpl/Preferences",
          label: "偏好设置",
          nodeIcon: "icon-tree icon-setting",
          route: {
            path: "/tpl/Preferences"
          }
        },
        {
          id: "/tpl/digital",
          label: "数字证书授权",
          nodeIcon: "icon-tree icon-tpl10",
          route: {
            path: "/tpl/digital"
          }
        },
        // {
        //   id: "/tpl/signers",
        //   label: "常用签署方",
        //   nodeIcon: "icon-tree icon-qsr",
        //   route: {
        //     path: "/tpl/signers"
        //   }
        // },
      ],
      personMenus: [
        // 个人账户
        {
          id: "/tpl/accountInfo",
          label: "账户信息",
          nodeIcon: "icon-tree icon-zh",
          route: {
            path: "/tpl/accountInfo"
          }
        },
        {
          id: "/tpl/personSet",
          label: "印章管理",
          nodeIcon: "icon-tree icon-tpl2",
          route: {
            path: "/tpl/personSet"
          }
        },
        {
          id: "/tpl/general",
          label: "模板管理",
          nodeIcon: "icon-tree icon-tpl1",
          route: {
            path: "/tpl/general"
          }
        },
        {
          id: "/tpl/myAuth",
          label: "我的授权",
          nodeIcon: "icon-tree icon-tpl2",
          route: {
            path: "/tpl/myAuth"
          }
        },
        {
          id: "/tpl/costStatistics",
          label: "消费统计",
          nodeIcon: "icon-tree icon-tj",
          route: {
            path: "/tpl/costStatistics"
          }
        },
        {
          id: "/tpl/Preferences",
          label: "偏好设置",
          nodeIcon: "icon-tree icon-setting",
          route: {
            path: "/tpl/Preferences"
          }
        },
        // {
        //   id: "/tpl/signers",
        //   label: "常用签署方",
        //   nodeIcon: "icon-tree icon-qsr",
        //   route: {
        //     path: "/tpl/signers"
        //   }
        // },
      ],
      groupList: [],
      operGroupType: {},
      dialogFormVisible: false,
      currentMenuName: "" // 当前匹配的菜单名称，用于传递给routeName组件
    };
  },
  computed: {
    ...mapGetters(["allAuthUser", "currentAuthUser"]),
    accountInfoVO () {
      if (this.allAuthUser && this.allAuthUser.accountInfoVO) {
        return this.allAuthUser.accountInfoVO;
      }
      return {};
    },
    showMenuTree () {
      let showTree = true;
      this.ignoreLayout.forEach(path => {
        if (path === this.$route.path) {
          showTree = false;
        }
      });
      return showTree;
    },
    currentAuthUser () {
      return this.$store.getters.currentAuthUser || {};
    },
    menus () {
      // 外部账户
      if (this.currentAuthUser.userType !== undefined) { 
        if (this.currentAuthUser.userType == 0) {
          let newPerMemu = this.$utils.clone(this.personMenus);
          // let perMumn = isInDingTalk ? newPerMemu : this.personMenus
          if(isInDingTalk) {
            // 钉钉移除我的授权（钉钉没有saasAPI功能）
            // 过滤相关菜单
            newPerMemu = newPerMemu.filter(item => !['/tpl/myAuth','/tpl/costStatistics','/tpl/accountInfo'].includes(item.id));
          }
          const _PerMemu = this.accountInfoVO.digitalCertificateSwitch && !isInDingTalk
            ? this.personMenusAll
            : newPerMemu;
          return _PerMemu;
        } else if (this.currentAuthUser.userType == 1) {
          let allMenus = [
            {
              id: "/tpl/digital",
              label: "数字证书授权",
              nodeIcon: "icon-tree icon-tpl10",
              route: {
                path: "/tpl/digital"
              }
            },
            {
              id: "/tpl/signMerge",
              label: "签署设置",
              nodeIcon: "icon-tree icon-tpl3",
              route: {
                path: "/tpl/signMerge"
              }
            }
          ];
          let filterMenus = [
            {
              id: "/tpl/signMerge",
              label: "签署设置",
              nodeIcon: "icon-tree icon-tpl3",
              route: {
                path: "/tpl/signMerge"
              }
            }
          ];
          return this.accountInfoVO.digitalCertificateSwitch
            ? allMenus
            : filterMenus;
        }
      }
      // 集团账户
      if (this.currentAuthUser.superFlag !== undefined) {
        return [
          {
            id: "/tpl/corpSet",
            label: "印章管理",
            nodeIcon: "icon-tree icon-tpl2",
            route: {
              path: "/tpl/corpSet"
            }
          },
          {
            id: "/tpl/general",
            label: "模板管理",
            nodeIcon: "icon-tree icon-tpl1",
            route: {
              path: "/tpl/general"
            }
          },
          {
            id: "/tpl/myAuth",
            label: "我的授权",
            nodeIcon: "icon-tree icon-tpl2",
            route: {
              path: "/tpl/myAuth"
            }
          },
          {
            id: "/tpl/costStatistics",
            label: "消费统计",
            nodeIcon: "icon-tree icon-tj",
            route: {
              path: "/tpl/costStatistics"
            }
          },
          {
            id: "/tpl/Preferences",
            label: "偏好设置",
            nodeIcon: "icon-tree icon-setting",
            route: {
              path: "/tpl/Preferences"
            }
          },
          {
            id: "/tpl/accountInfo",
            label: "账户信息",
            nodeIcon: "icon-tree icon-zh",
            route: {
              path: "/tpl/accountInfo"
            }
          },
          // {
          //   id: "/tpl/signers",
          //   label: "常用签署方",
          //   nodeIcon: "icon-tree icon-qsr",
          //   route: {
          //     path: "/tpl/signers"
          //   }
          // },
        ];
      }
    },
    computedCurrentMenuName () {
      return this.currentMenuName;
    },
    isSecondaryMenu () {
      let obj = {
        "/tpl/add/general": {
          parentPath: "/tpl/general",
          routeName: "新增模板"
        },
        "/tpl/add/api": {
          parentPath: "/tpl/general",
          routeName: "新增api模板"
        },
        "/tpl/add/apply": {
          parentPath: "/tpl/general",
          routeName: "使用模板"
        },
        "/tpl/add/sysContract": {
          parentPath: "/tpl/general",
          routeName: "使用模板"
        }
      };
      return obj[this.$route.path];
    }
  },
  created() {
    let user = this.$store.getters.allAuthUser.accountInfoVO;
    setCurrentUser(user).finally(() => {

    });
  },
  mounted() {
    //用户切换提示
    this.userTipVisible = localStorage.getItem('userTipVisible');
    if (!this.userTipVisible && !isInDingTalk && this.allAuthUser.bindCorpUsers.length) {
      this.userTipdialogVisible = true;
      setTimeout(() => {
        this.userTipdialogVisibleFn();
      }, 4000);
    }
  },
  methods: {
    userTipdialogVisibleFn() {
      localStorage.setItem('userTipVisible', '1');
      this.userTipdialogVisible = false;
    },
    /**
     *  上一步跳转链接
     * */
    previousStep () {
      let { control } = this.$route.query;
      if (control && control == 1) {
        // 从控制台过来就返回控制台
        this.$router.push({ path: "/console/template" });
        return;
      }
      let backPath = this.isSecondaryMenu;
      // let arr = ['/tpl/add/general','/tpl/add/api']
      if (backPath) {
        // this.$router.back()
        this.$router.push({ path: backPath.parentPath });
      } else {
        this.$router.push({ path: "/viewIndex" });
      }
    },
    initMenuTree () {
      // 查询 API 模板分类（企业用户激活API）
      if (this.currentAuthUser.merchantFlag === 1) {
        // this.queryGroupTypeList();
      }
    },
    tabHand () {
      try {
        if (this.$route.path === this.menus[0].route.path) return
        if (isInDingTalk) {
          this.$router.push({ path: this.menus[0].route.path }, () => { }, () => { })
        }
      } catch (err) {
        console.log('tplRouter_err', err)
      }
    },
    //  *********************************** api模板分类 start ***********************************
    async queryGroupTypeList () {
      this.groupList = [];
      let result = await ApiMethods.ApiTemplateController.tplGroupType({});
      if (result.success && result.data) {
        // 根据查询到的模板分类，组装tree
        result.data.forEach(tpl => {
          let tplObj = {
            id: `/tpl/api?tplTypeId=${tpl.tplGroupTypeId}`,
            label: tpl.tplGroupTypeName,
            route: {
              path: "/tpl/api",
              query: {
                tplTypeId: tpl.tplGroupTypeId
              }
            },
            slotClass: "showWhenHover",
            slots: [
              {
                clickFunc: () => {
                  this.showOperGroupType(tpl);
                },
                iconClass: "el-icon-edit",
                hoverTitle: "修改"
              },
              {
                clickFunc: () => {
                  this.delGroupTypeTpl(tpl.tplGroupTypeId);
                },
                iconClass: "el-icon-close",
                hoverTitle: "删除"
              }
            ]
          };
          this.groupList.push(tplObj);
          tplObj = null;
        });
        let unTyped = {
          id: `/tpl/api?tplTypeId=-1`,
          label: "未分类",
          route: {
            path: "/tpl/api",
            query: {
              tplTypeId: -1
            }
          }
        };
        this.groupList.push(unTyped); // 加入未分类
      } else {
        this.$message.error(result.description || this.$tip);
      }
      // 调用树形菜单的resetTree方法
      this.$nextTick(() => {
        if (this.$refs.menuTree) {
          this.$refs.menuTree.resetTree();
        }
      });
    },
    delGroupTypeTpl: function (tplGroupTypeId) {
      this.$confirm("确认删除分类?", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          var param = { tplGroupTypeId: tplGroupTypeId };
          ApiMethods.ApiTemplateController.delTplGroupType(param).then(
            result => {
              if (result.success) {
                this.$alert("操作成功", "系统提示", {
                  confirmButtonText: "确定",
                  callback: action => {
                    this.queryGroupTypeList();
                  }
                });
              } else {
                this.$alert(
                  result.description || "操作失败,该分类下存在数据",
                  "系统提示"
                );
                console.error(
                  "==info[20180720/115027.198]==" + result.description
                );
              }
            }
          );
        })
        .catch(() => { });
    },
    showOperGroupType (tplObj) {
      if (tplObj !== undefined) {
        this.operGroupType = JSON.parse(JSON.stringify(tplObj));
      } else {
        this.operGroupType = {};
      }
      this.dialogFormVisible = true;
    },
    saveOrUpdateGroupType: function () {
      if (!this.operGroupType.tplGroupTypeName)
        return this.$message.error("请输入模板名称");
      if (this.operGroupType.tplGroupTypeName.length > 10)
        return this.$message.error("模板名称不能超过10个字符");
      var param = this.operGroupType;
      ApiMethods.ApiTemplateController.operTplGroupType(param).then(result => {
        if (result.success) {
          this.queryGroupTypeList();
          this.dialogFormVisible = false;
        } else {
          this.$message.error(result.description || this.$tip);
        }
      });
    }
    //  *********************************** api模板分类 end ***********************************
  },
  head: { title: "君子签" },
  name: "tpl"
  // layout: "entconsolelayout"
};
</script>

<style lang="less" scoped>
@import (less) "../assets/style/icon.css";
.tpl {
  .main-wrap {
    height: calc(100vh - 140px);

    .left-wrap {
      height: 100%;
      float: left;
      width: 200px;
      background-color: #ffffff;

      /deep/ .publish {
        padding: 15px 0;
        text-align: left;
        border-bottom: solid 1px #e5e5e5;

        .upload-file {
          width: 80%;
          margin-left: 10%;

          input[type="file"] {
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
          }

          .el-button {
            width: 100%;
          }
        }

        .tpl {
          width: 80%;
          margin-left: 10%;
          margin-bottom: 0;
        }
      }
    }

    .right-wrap {
      margin-left: 215px;
      height: 100%;
      background-color: #ffffff;
      overflow-y: auto;

      .table-wrap {
        padding: 0 16px;
      }

      /deep/ .row {
        padding: 15px;
        height: 62px;
        min-height: 62px;
      }

      /deep/ .data-list {
        height: calc(100vh - 296px);
        width: inherit;
        margin: 0 15px;
        border: 1px solid #cdcdcd;
        overflow-y: auto;
      }

      /deep/ .go-style {
        top: 18px;
      }

      /deep/ .pageation {
        position: relative;
      }
    }
  }

  .header {
    max-width: 1200px;
    margin: 0 auto 20px;
  }

  .menu {
    overflow: hidden;
    margin-top: 10px;
    margin-bottom: 10px;

    .nav-bar {
      width: 100%;

      .nav-item {
        font-size: 15px;
        color: #666666;
        margin-right: 40px;

        .nuxt-link {
          vertical-align: middle;
        }
      }

      .nav-item:before {
        content: "";
        display: inline-block;
        width: 2px;
        height: 18px;
        background: #ffffff;
        vertical-align: middle;
        margin-right: 6px;
      }

      .nav-item.active:before {
        background: #ec1c1c;
      }

      .nav-item.active {
        .nuxt-link {
          color: #ec1c1c;
        }

        color: #ec1c1c;
      }
    }
  }
}

/deep/ .el-tree {
  .el-tree-node.is-checked {
    .icon-zh {
      .icon-zh-on();
    }
    .icon-tj {
      .icon-tj-on();
    }
    .icon-mm {
      .icon-mm-on();
    }
    .icon-sqr {
      .icon-sqr-on();
    }
    .icon-qsr {
      .icon-qsr-on();
    }
    .icon-mb {
      .icon-mb-on();
    }
    .icon-z {
      .icon-z-on();
    }
    .icon-mm {
      .icon-mm-on();
    }
    .icon-sqr {
      .icon-sqr-on();
    }

    .icon-tpl1 {
      .icon-tpl1-on();
    }
    .icon-tpl2 {
      .icon-tpl2-on();
    }
    .icon-tpl3 {
      .icon-tpl3-on();
    }
    .icon-tpl4 {
      .icon-tpl4-on();
    }
    .icon-tpl5 {
      .icon-tpl5-on();
    }
    .icon-tj {
      .icon-tj-on();
    }
  }
  .icon-tree {
    width: 15px;
    height: 15px;
    margin-right: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// pages/tpl.vue